import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  static outlets = ['selectable-table']
  static values = { schoolId: Number }

  selectionChanged(_event) {
    for (const button of this.buttonTargets) {
      button.disabled = !this.selectableTableOutlet.hasSelectedRows()
    }
  }

  email() {
    const path = `/s/${this.schoolIdValue}/emails?via=email&child_ids=${this.selectedIds().join()}`

    window.open(path, 'email')
  }

  text() {
    const path = `/s/${this.schoolIdValue}/emails?via=sms&child_ids=${this.selectedIds().join()}`

    window.open(path, 'email')
  }

  selectedIds() {
    return this.selectableTableOutlet.selectedIds()
  }
}
